<template>
  <div>
    <div :class="divWidthChange" class="conteudoWidth">
      <div class="row mt-3">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="fields"
            :orderby="sortBy"
            :actions="actions"
            :items="lstNecessidadeEspecifica"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            :titlePage="titlePage"
            :titlePDF="titlePage"
          >
          </fccTable>
        </div>
      </div>
    </div>
    <fccModal
      centered
      idModal="addFieldTipoDeficiencia"
      :titleModal="titleModal"
      escondeFooter
      @close="criar = {}"
      travaEsc
      travaBack
    >
      <form
        @submit.prevent="
          criar.tpdeficiencia == 0 ? criarTipoDeficiencia() : editarTipoDeficiencia()
        "
        autocomplete="off"
      >
        <div class="row">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" required v-model="criar.deficiencia"
              >Tipo deficiência</fccInput
            >
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-sm-12 text-right">
            <fccButton tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
    <fccModal
      centered
      idModal="solicitacaoTDeficiencia"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      @close="criar = {}"
      travaBack
      size="lg"
    >
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Tipo Deficiência',
      itemPorPage: '100',
      lstNecessidadeEspecifica: [],
      lstSolicitacaoEspecifica: [],
      lstServidores: [],
      mostraSenha: false,
      titleModal: '',
      criar: {},
      fields: [
        { key: 'idnecessidadepublicacao', label: 'ID', sortable: true, active: true },
        { key: 'solicitacao', label: 'Solicitação', sortable: true, active: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'deleteNecessidade',
          icon: 'trash',
          tooltip: 'Deletar',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ]
    }
  },
  props: {
    idPublicacao: {
      type: Number,
      required: true
    }
  },
  methods: {
    listarNecessidadeCondicacaoEspecifica() {
      this.listaNecessidadeSolicitacaoCondicaoEspecificaPublicacao(this.idPublicacao)
        .then((response) => {
          this.lstNecessidadeEspecifica = response
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    sucessoSituacao(texto) {
      this.listarNecessidadeCondicacaoEspecifica()
      this.callToast(texto)
    },
    deleteNecessidade(_, item) {
      this.callConfirm(this.mensagemExcluir, item.solicitacao).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C03'))
          axios
            .delete(
              this.baseUrlLaudoMedico +
                'NecessidadeSolicitacaoCondicaoEspecificaPublicacao/Excluir/' +
                item.idnecessidadepublicacao,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.sucessoSituacao(this.mensagensUpdate.excluido)
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
            .finally(this.carregaTexto)
        }
      })
    }
  },
  mounted() {
    this.listarNecessidadeCondicacaoEspecifica()
  }
}
</script>
        